<template>
    <div class="g-input">
        <form action="#" @submit.prevent>
            <input
                ref="input"
                type="search"
                class="text-input"
                :placeholder="value ? '' : hotWord"
                :value="value"
                @focus="handleInputFocus"
                @click="handleInputClick"
                @input="handleTextChange"
                @keyup.enter="handleEnter"
                :autofocus="false"
            />
        </form>
        <i
            class="close-btn"
            v-if="value.length"
            @mousedown.prevent="handleClose"
        ></i>
    </div>
</template>

<script>
// mixin
import SystemMixin from '@/mixins/system'

import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'GInput',
    mixins: [SystemMixin],
    computed: {
        ...mapGetters([
            'hotWord'
        ])
    },
    props: {
        value: {
            type: String,
            required: true,
            default: ''
        },
        autofocus: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        ...mapMutations([
            'updateHotWords'
        ]),
        handleInputFocus (event) {
            event.stopPropagation()
            event.preventDefault()
        },
        handleInputClick (event) {
        },
        handleTextChange ({ target: { value }}) {
            this.$emit('update:value', value)
        },
        handleClose () {
            this.$emit('update:value', '')
        },
        handleEnter () {
            this.$emit('enter')
        },
        async getHotWords () {
            if (this.hotWord) return

            try {
                const { data } = await this.$http.get('/idun/search/hot_words')
                this.updateHotWords(data.hot_words)
                console.log(data)
            } catch (e) {
                console.log(e)
            }
        }
    },
    mounted () {
        if (this.autofocus) this.$refs['input'].focus()
        this.getHotWords()
    }
}
</script>

<style lang="less" scoped>
.g-input {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    form {
        flex: 1;
    }
    .text-input {
        width: 100%;
        padding: 12px;
        height: 16px;
        line-height: 16px;
        font-size: 15px;
        color: #444;
        &:disabled {
            background-color: rgba(0, 0, 0, 0);
        }
    }
    .close-btn {
        display: block;
        padding: 10px;
        width: 11.5px;
        height: 11.5px;
        background: url(../assets/close-input.png) no-repeat center;
        background-size: 11.5px 11.5px;
        position: absolute;
        right: 1px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/GInput.vue